import { Link as MuiLink, LinkProps as MuiLinkProps } from '@mui/material';
import type { ElementType, MouseEvent } from 'react';
import { toExternalLinkProps, toLinkProps } from '../utils/toLinkProps';

export const LINK_HOVER_GROUP = 'link-hover-group';

type Props = Pick<MuiLinkProps, 'children' | 'className' | 'sx'> & {
  color?: 'primary' | 'inherit' | 'text.primary' | 'text.secondary';
  underline?: 'hover' | 'always' | 'none';
  to?: string;
  href?: string;
  testId?: string;
  title?: string;
  role?: React.AriaRole;
  component?: ElementType;
  onClick?: (event: MouseEvent<HTMLElement>) => void;
};

const Link = ({
  color = 'primary',
  underline = 'none',
  to,
  href,
  testId,
  title,
  role,
  component,
  children,
  className,
  sx,
  onClick,
}: Props) => {
  const navigationProps =
    toLinkProps(to) ?? toExternalLinkProps(href) ?? (component ? { component } : {});

  return (
    <MuiLink
      color={color}
      underline={underline}
      className={className}
      title={title}
      role={role}
      onClick={onClick}
      test-id={testId}
      sx={[
        {
          cursor: 'pointer',
          [`&:hover, .${LINK_HOVER_GROUP}:hover &`]: { color: 'primary.main' },
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...navigationProps}
    >
      {children}
    </MuiLink>
  );
};

export type { Props as LinkProps };
export default Link;
